import type { NskResponse } from "~/models/Api";
import { postRequest } from "~/utils/api/api_handler";
import { generatePath } from "~/utils/generatePath";

export const paths = {
	create: (dealId: number) =>
		generatePath("/vendors/deals/:deal_id/deal_inspection_report_completes", {
			deal_id: dealId
		})
};

export const create = async (dealId: number): Promise<NskResponse> =>
	postRequest(paths.create(dealId));
